
const digest = 'e00b9d1b7022d68d6ccd71240346635a77607db8376bd0a25eae277ec577a819';
const classes = {"boxes":"_boxes_353ne_1"};
const css = `._boxes_353ne_1 {
  display: flex;
  flex-wrap: wrap;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  